// src/pages/HomePage.mobile.js

import React from 'react';
import {
  Container, Box, Typography, Button, Stack, Accordion,
  AccordionSummary, AccordionDetails, Grid, Avatar, ButtonBase,
  Dialog, DialogContent, DialogTitle, IconButton, TextField, FormControl,
  InputLabel, Select, MenuItem,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import { motion } from 'framer-motion';
import bg from "../assets/new.png"; //final_design.png
// Carousel Imports (assuming react-slick is pre-installed)
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";


// Component Imports
import BlurText from '../components/BlurText';
import RotatingText from '../components/RotatingText';
import Stepper, { Step } from '../components/Stepper';
import TextType from '../components/TextType'; // Import TextType component

// A small helper to map string names to actual icon components


function HomePageMobile(props) {
  const {
    navigate, containerVariants, itemVariants, contactActions,
    isSpeedDialOpen, handleSpeedDialOpen, handleSpeedDialClose, stepperOpen,
    handleStepperClose, onStepperCompleted, issue, setIssue, orderId, setOrderId,
    details, setDetails
  } = props;

  // Ensure the page uses at least 800px viewport height on small devices:
  // If window is available, take max(window.innerHeight, 800), otherwise default to 800.
  const viewportHeight = (typeof window !== 'undefined') ? Math.max(window.innerHeight, 800) : 800;
  const containerHeight = `${viewportHeight - 64}px`; // match previous calc(100vh - 64px)

  // --- Carousel Data & Settings ---
  const carouselItems = [
    {
      image: bg,
    }
  ];

  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'linear',
  };


  return (
    <Box sx={{ backgroundColor: '#ffffff' }}>
      {/* SECTION 1: Main Landing Carousel */}

      {/* SECTION 1: Main Landing Carousel */}
      <Box sx={{ position: 'relative', height: containerHeight, width: '100%', overflow: 'hidden', color: 'white' }}>
        <Slider {...sliderSettings}>
          {carouselItems.map((item, index) => (
            <Box
              key={index}
              sx={{
                height: containerHeight,
                backgroundImage: `url(${item.image})`,
                // EDITED: Use responsive values for backgroundSize
                backgroundSize: {
                  xs: '120% auto', // On extra-small screens, force width to 100%
                  md: '135% auto'      // On medium screens and up, cover the container
                },
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
              }}
            />
          ))}
        </Slider>

        {/* Overlay for Content */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            p: 3,
            '& .slick-dots': {
              bottom: '25px',
              '& li button:before': {
                color: 'white',
                opacity: 0.7,
                fontSize: '10px',
                textShadow: '0px 0px 4px rgba(0,0,0,0.8)', // Shadow for visibility
              },
              '& li.slick-active button:before': {
                opacity: 1,
              }
            }
          }}
        >
          <Container maxWidth="md">
            <motion.div variants={containerVariants} initial="hidden" animate="visible">
              <motion.div variants={itemVariants}>
                <Box sx={{ mt: 6, mb: -2 }}>
                  <Typography variant="h4" component="h1" fontWeight={800} sx={{ color: '#75a84b', mt: -12 }}>Fresh Produce</Typography>
                  <Typography variant="h4" component="h1" fontWeight={800} sx={{ color: '#75a84b', }}>Backed by</Typography>
                  <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
                    <Box sx={{ display: 'inline-flex', ml: 0, mt: 0, bgcolor: '#75a84b', overflow: 'hidden', borderRadius: 2, color: 'white', }}>
                      <RotatingText texts={['Great Service', 'Low Prices']} mainClassName="px-2 overflow-hidden py-1 justify-center" staggerFrom={"last"} initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "-120%" }} staggerDuration={0.025} splitLevelClassName="overflow-hidden pb-1" transition={{ type: "spring", damping: 30, stiffness: 400 }} rotationInterval={4000} />
                    </Box>
                  </Typography>
                </Box>
              </motion.div>
              <motion.div variants={itemVariants}>
                <Box sx={{ color: '#75a84b', mb: 2, mt: 30 }}> {/* Adjusted margin from 4 for better spacing */}
                  <Typography variant="body1" className="text-lg text-gray-800" fontWeight={800}>
                    Premium fruits and vegetables, delivered straight to your business 7 days a week. Count on us for consistent quality, unbeaten prices and reliable service you can trust.
                  </Typography>
                </Box>
              </motion.div>
              <motion.div variants={itemVariants}>
                <Stack direction="column" spacing={2} sx={{ mb: 0, alignItems: 'center' }}>
                  <Button variant="contained" size="large" sx={{ py: 1.5, px: 4, fontWeight: 'bold', bgcolor: '#75a84b', color: 'white', '&:hover': { bgcolor: '#75a84b' }, borderRadius: '50px', textTransform: 'none', fontSize: '1rem', minWidth: '240px', boxShadow: '0 4px 14px 0 rgba(0,0,0,0.2)' }} onClick={() => navigate('/register')}>Become a Customer</Button>
                  <Button variant="outlined" size="large" sx={{ py: 1.5, px: 4, fontWeight: 'bold', bgcolor: '#75a84b', color: 'white', '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.1)', borderColor: 'white' }, borderRadius: '50px', textTransform: 'none', fontSize: '1rem', minWidth: '240px', backdropFilter: 'blur(2px)' }} onClick={() => navigate('/login')}>Login to Order</Button>
                </Stack>
              </motion.div>
            </motion.div>
          </Container>
        </Box>
      </Box>






      {/* --- CONTACT SPEED DIAL --- */}

      {/* --- SUPPORT STEPPER DIALOG --- */}
      <Dialog open={stepperOpen} onClose={handleStepperClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Support
          <IconButton aria-label="close" onClick={handleStepperClose} sx={{ color: (theme) => theme.palette.grey[500] }}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Stepper onFinalStepCompleted={onStepperCompleted} backButtonText="Back" nextButtonText="Next">
            <Step>
              <Typography variant="h6" gutterBottom>Help us understand your issue</Typography>
              <FormControl fullWidth margin="normal">
                <InputLabel id="issue-select-label">Query about?</InputLabel>
                <Select labelId="issue-select-label" value={issue} label="Query about?" onChange={(e) => setIssue(e.target.value)}>
                  <MenuItem value="Billing">Billing Question</MenuItem>
                  <MenuItem value="Delivery">Delivery Issue</MenuItem>
                  <MenuItem value="Product Quality">Product Quality</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
            </Step>
            <Step>
              <Typography variant="h6" gutterBottom>Order Information</Typography>
              <TextField fullWidth margin="normal" label="Order ID (if applicable)" value={orderId} onChange={(e) => setOrderId(e.target.value)} placeholder="e.g., #12345" />
            </Step>
            <Step>
              <Typography variant="h6" gutterBottom>Describe the issue</Typography>
              <TextField fullWidth multiline rows={4} margin="normal" label="Please provide more details" value={details} onChange={(e) => setDetails(e.target.value)} />
            </Step>
            <Step>
              <Typography variant="h6" gutterBottom>Ready to Submit</Typography>
              <Typography variant="body2">Click 'Finish' to create a support ticket.</Typography>
            </Step>
          </Stepper>
        </DialogContent>
      </Dialog>
    </Box>
  );

}


export default HomePageMobile;
